import React from 'react';

import styles from './styled-table.module.scss';
export const Row = ({ className, ...props }: React.ComponentPropsWithoutRef<'div'>) => (
  <div className={className ? `${styles['row']} ${className}` : styles['row']} {...props} />
);

export const Cell = ({ className, ...props }: React.ComponentPropsWithoutRef<'div'>) => (
  <div className={className ? `${styles['cell']} ${className}` : styles['cell']} {...props} />
);

export const ActionBox = ({ className, ...props }: React.ComponentPropsWithoutRef<'div'>) => (
  <div
    className={className ? `${styles['action-box']} ${className}` : styles['action-box']}
    {...props}
  />
);
